import { RootState } from '..';
import { Module } from "vuex";

interface WordmapsState {
  mapUrlsDoc?: {
    [word: string]: string;
  };
}

function loadMapUrls() {
  return fetch('https://lidate.ch/api/mapurls').then(response => {
    return response.json();
  }).catch(err => {
    console.error(err);
    return {};
  })
}

//poll async function every 30 seconds


const WordmapsModule: Module<WordmapsState, RootState> = {
  namespaced: true,
  state() {
    return {
      mapUrlsDoc: undefined,
    }
  },  
  actions: {
    bindMapUrls: ({commit}) => {
      const load = function() {
        loadMapUrls().then(mapUrls => {
          commit('setMapUrls', mapUrls);
        });
      };

      setInterval(load, 30000);
      return load();
    }
  },
  mutations: {
    setMapUrls(state, mapUrls) {
      state.mapUrlsDoc = mapUrls;
    },
  },

  getters: {
    mapUrls: (state) => state.mapUrlsDoc
  }
}

export default WordmapsModule
